import isEqual from 'lodash/isEqual';
import { useAppSelector } from '../store';

export default function useMetadata() {
  return useAppSelector(state => state.metadata.data, isEqual);
}
